import { createSlice } from '@reduxjs/toolkit'

export interface ITwoFactorModalState {
  isOpen: boolean
}

const initialState: ITwoFactorModalState = {
  isOpen: false,
}

export const twoFactorModalSlice = createSlice({
  name: 'twoFactorModal',
  initialState,
  reducers: {
    openModal: (state) => {
      state.isOpen = true
    },
    closeModal: (state) => {
      state.isOpen = false
    },
  },
})

export const { openModal, closeModal } = twoFactorModalSlice.actions
export default twoFactorModalSlice.reducer
